import React from 'react'
import banner from '../img/banner.png'

export default function Hero({ onContactClick }) {
  return (
    <header className="hero">
      <div className="hero-overlay" >
          <img className="logo-banner" src={banner} alt="Banner" width="100%" height="40%" />
      </div>
     
      <div className="hero-inner">
        <span className="hero-badge">Desenvolvimento Web &amp; Mobile</span>
        <h1 className="hero-title">
          Soluções digitais que<br />
          elevam o seu negócio
        </h1>
        <p className="hero-sub">
          Criamos sistemas, sites e aplicativos personalizados
          para empresas que querem crescer na internet.
        </p>
        <div className="hero-actions">
          <button className="btn btn-primary" onClick={onContactClick}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Fale com a gente
          </button>
          <a
            href="https://www.instagram.com/f.fsolutions/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
            </svg>
            Instagram
          </a>
        </div>
      </div>
    </header>
  )
}
